<template>
  <RevDialog
    :close-button-label="i18n(translations.close)"
    :name
    v-bind="$attrs"
  >
    <template #trigger="{ open }">
      <slot v-bind="{ open }" name="trigger" />
    </template>

    <template #body>
      <div class="h-[80vh] w-auto">
        <YoutubeEmbedded
          class="rounded-lg overflow-hidden"
          :title
          :youtube-id
        />
      </div>
    </template>
  </RevDialog>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevDialog } from '@ds/components/Dialog'

import YoutubeEmbedded from '../YoutubeEmbedded/YoutubeEmbedded.vue'

import translations from './YoutubeVideoModal.translations'

const i18n = useI18n()

defineOptions({
  inheritAttrs: false,
})

defineProps<{ youtubeId: string; title: Maybe<string>; name: string }>()
</script>
